import React from "react"

export default function Arrow() {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 16 14.2"
      style={{ enableBackground: "new 0 0 16 14.2" }}
    >
      <path d="M15.7,8.2L8.6,14c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0-0.6-0.2L0.3,8.2C0.1,8,0,7.8,0,7.5C0,7.3,0,7.1,0.2,7c0.3-0.4,0.9-0.4,1.3-0.1l5.7,4.6V0.9C7.1,0.4,7.5,0,8,0s0.9,0.4,0.9,0.9v10.5l5.7-4.6c0,0,0,0,0,0c0.4-0.3,0.9-0.3,1.2,0.1C16.1,7.3,16,7.9,15.7,8.2z" />{" "}
    </svg>
  )
}
